// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1rxor","footer":"Form_footer__fs2fp"};